import UserFigure from "./UserFigure"
export default UserFigure
